<template>
  <div :class="$style['pt-old-to-new-table']">
      <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" isAddPageToRouter :isOutside="isOutside">
        <wt-table :labels="tableLabels" :list="tableData" @select="select" :isSelect="true" :border="false" @select-all="selectAll">
            <template slot="before" v-if="selectTab==='ALL'">
                <el-table-column label="序号" min-width="100">
                    <template slot-scope="scope">
                        {{scope.row.serialNumber}}
                    </template>
                </el-table-column>
                <el-table-column label="达标时间" min-width="100">
                    <template slot-scope="scope">
                        {{scope.row.achieve_date}}
                    </template>
                </el-table-column>
                <el-table-column label="邀请人(老用户)"  header-align="center">
                    <el-table-column label="手机号" min-width="110">
                    <template slot-scope="scope">
                        <!-- <div>{{scope.row.oldCustomer&&scope.row.oldCustomer.userName}}</div> -->
                        <div>{{scope.row.oldCustomer&&scope.row.oldCustomer.userMobile}}</div>
                    </template>
                    </el-table-column>
                    <el-table-column label="合同姓名">
                    <template slot-scope="scope">
                      <template v-if="scope.row.oldCustomer&&scope.row.oldCustomer.contractInformation&&scope.row.oldCustomer.contractInformation.length">
                      <div v-for="(item,i) in scope.row.oldCustomer.contractInformation" :key="i">
                         <!-- <template v-if="item.productInformation&&item.productInformation.length">
                          <div v-for="(etem,index) in item.productInformation" :key="index">
                             {{etem.motherName?etem.motherName:'--'}}
                          </div>
                          </template>
                          <template v-else>--</template> -->
                        {{item.motherName?item.motherName:'--'}}
                      </div>
                      </template>
                      <template v-else>--</template>
                    </template>
                    </el-table-column>
                    <el-table-column label="CPS合同" min-width="180">
                    <template slot-scope="scope">
                      <template v-if="scope.row.oldCustomer&&scope.row.oldCustomer.contractInformation&&scope.row.oldCustomer.contractInformation.length">
                      <div v-for="(item,i) in scope.row.oldCustomer.contractInformation" :key="i">
                         <!-- <template v-if="item.productInformation&&item.productInformation.length">
                          <div v-for="(etem,index) in item.productInformation" :key="index">
                             {{etem.contractCode?etem.contractCode:'--'}}
                          </div>
                          </template>
                          <template v-else>--</template> -->
                        {{item.contractCode?item.contractCode:'--'}}
                        <!-- <div>{{scope.row.oldCustomer&&scope.row.oldCustomer.CPSNumber}}</div> -->
                      </div>
                      </template>
                      <template v-else>--</template>
                    </template>
                    </el-table-column>
                    <el-table-column label="地区">
                      <template slot-scope="scope">
                      <template v-if="scope.row.oldCustomer&&scope.row.oldCustomer.contractInformation&&scope.row.oldCustomer.contractInformation.length">
                        <div v-for="(item,i) in scope.row.oldCustomer.contractInformation" :key="i">
                          <!-- <template v-if="item.productInformation&&item.productInformation.length">
                          <div v-for="(etem,index) in item.productInformation" :key="index">
                             {{etem.cpsRegion?etem.cpsRegion:'--'}}
                          </div>
                          </template>
                          <template v-else>--</template> -->
                          {{item.cpsRegion?item.cpsRegion:'--'}}
                        </div>
                      </template>
                      <template v-else>--</template>
                        <!-- <div>{{scope.row.oldCustomer&&scope.row.oldCustomer.cpsRegion}}</div> -->
                      </template>
                    </el-table-column>
                    <el-table-column label="产品" min-width="180">
                      <template slot-scope="scope">
                        <template v-if="scope.row.oldCustomer&&scope.row.oldCustomer.contractInformation&&scope.row.oldCustomer.contractInformation.length">
                        <div v-for="(item,i) in scope.row.oldCustomer.contractInformation" :key="i"  :class="i+1<scope.row.oldCustomer.contractInformation.length?'production-name-code-buttom':null" >
                          <template v-if="item.productInformation&&item.productInformation.length">
                          <div v-for="(etem,index) in item.productInformation" :key="index">
                            {{etem.name?etem.name:"--"}}
                             <!-- {{etem.name?(etem.name+(etem.productCode?("-"+etem.productCode):'')):'--'}} -->
                          </div>
                          </template>
                          <template v-else>--</template>
                        </div>
                        </template>
                        <template v-else>--</template>
                      </template>
                    </el-table-column>
                    <el-table-column label="奖励轮次">
                      <template slot-scope="scope">
                        {{scope.row.finalRewardCount}}
                      </template>
                    </el-table-column>
                    <el-table-column label="业务员">
                      <template slot-scope="scope">
                      <template v-if="scope.row.oldCustomer&&scope.row.oldCustomer.contractInformation&&scope.row.oldCustomer.contractInformation.length">
                        <div v-for="(item,i) in scope.row.oldCustomer.contractInformation" :key="i">
                          {{item.salesName?item.salesName:"--"}}
                        </div>
                      </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="返现金额/返券金额">
                    <template slot-scope="scope">
                        <div>{{scope.row.oldCustomer&&(scope.row.oldCustomer.moneyRewardAmount)||'--'}}</div>
                        <div>{{scope.row.oldCustomer&&(scope.row.oldCustomer.couponRewardAmount)||'--'}}</div>
                    </template>
                    </el-table-column>
                    <el-table-column label="发放状态/操作时间" min-width="120">
                        <template slot-scope="scope">
                            <div>{{scope.row.oldCustomer&&scope.row.oldCustomer.reward_status}}</div>
                            <div>{{scope.row.oldCustomer&&scope.row.oldCustomer.reward_date}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                  <el-table-column label="被邀请人(新用户)" header-align="center">
                    <el-table-column label="手机号"  min-width="110">
                    <template slot-scope="scope">
                        <!-- <div>{{scope.row.newCustomer&&scope.row.newCustomer.userName}}</div> -->
                        <div>{{scope.row.newCustomer&&scope.row.newCustomer.userMobile}}</div>
                    </template>
                    </el-table-column>
                    <el-table-column label="常住地区" min-width="130">
                      <template slot-scope="scope">
                        <template v-if="scope.row.newCustomer&&scope.row.newCustomer.region">
                        {{scope.row.newCustomer.region.provinceName+
                        scope.row.newCustomer.region.cityName+scope.row.newCustomer.region.districtName}}
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column label="合同姓名">
                      <template slot-scope="scope">
                        <template v-if="scope.row.newCustomer&&scope.row.newCustomer.contractInformation">
                        <div v-for="(item,i) in scope.row.newCustomer.contractInformation" :key="i">
                          {{item.motherName?item.motherName:'--'}}
                        </div>
                        </template>
                        <!-- <div>{{scope.row.newCustomer&&scope.row.newCustomer.CPSNumber}}</div> -->
                      </template>
                    </el-table-column>
                    <el-table-column label="CPS合同" min-width="180">
                    <template slot-scope="scope">
                      <template v-if="scope.row.newCustomer&&scope.row.newCustomer.contractInformation">
                      <div v-for="(item,i) in scope.row.newCustomer.contractInformation" :key="i">
                        {{item.contractCode?item.contractCode:'--'}}
                      </div>
                      </template>
                        <!-- <div>{{scope.row.newCustomer&&scope.row.newCustomer.CPSNumber}}</div> -->
                    </template>
                    </el-table-column>
                    <el-table-column label="地区">
                      <template slot-scope="scope">
                      <template v-if="scope.row.newCustomer&&scope.row.newCustomer.contractInformation">
                        <div v-for="(item,i) in scope.row.newCustomer.contractInformation" :key="i">
                          {{item.cpsRegion?item.cpsRegion:'--'}}
                        </div>
                      </template>
                        <!-- <div>{{scope.row.newCustomer&&scope.row.newCustomer.cpsRegion}}</div> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="产品" min-width="180">
                      <template slot-scope="scope">
                        <template v-if="scope.row.newCustomer&&scope.row.newCustomer.contractInformation&&scope.row.newCustomer.contractInformation.length">
                        <div v-for="(item,i) in scope.row.newCustomer.contractInformation" :key="i"  :class="i+1<scope.row.newCustomer.contractInformation.length?'production-name-code-buttom':null" >
                          <template v-if="item.productInformation&&item.productInformation.length">
                          <div v-for="(etem,index) in item.productInformation" :key="index">
                            {{etem.name?etem.name:"--"}}
                             <!-- {{etem.name?(etem.name+(etem.productCode?("-"+etem.productCode):'')):'--'}} -->
                          </div>
                          </template>
                          <template v-else>--</template>
                        </div>
                        </template>
                        <template v-else>--</template>
                        <!-- <template v-if="scope.row.newCustomer&&scope.row.newCustomer.contractInformation&&scope.row.newCustomer.contractInformation[0]&&scope.row.newCustomer.contractInformation[0].productInformation">
                          <div v-for="(item,i) in scope.row.newCustomer.contractInformation[0].productInformation" :key="i">
                            {{(item.name?(item.name+'-'+item.productCode):item.productCode)||'--'}}
                          </div>
                        </template>
                        <template v-else>--</template> -->
                        <!-- {{scope.row.newCustomer&&scope.row.newCustomer.productCode}} -->
                      </template>
                    </el-table-column>
                    <el-table-column label="业务员">
                      <template slot-scope="scope">
                      <template v-if="scope.row.newCustomer&&scope.row.newCustomer.contractInformation&&scope.row.newCustomer.contractInformation.length">
                        <div v-for="(item,i) in scope.row.newCustomer.contractInformation" :key="i">
                          {{item.salesName?item.salesName:"--"}}
                        </div>
                      </template>
                      </template>
                    </el-table-column>
                <!-- <el-table-column label="生产医院">
                 <template slot-scope="scope">
                <template v-if="scope.row.newCustomer&&scope.row.newCustomer.contractInformation&&scope.row.newCustomer.contractInformation.length">
                  <div v-for="(item,i) in scope.row.newCustomer.contractInformation" :key="i">
                    {{item.birthHospital?item.birthHospital:'--'}}
                  </div>
                </template>
                </template>
                </el-table-column> -->
                    <el-table-column label="返现金额/返券金额">
                    <template slot-scope="scope">
                        <div>{{scope.row.newCustomer&&(scope.row.newCustomer.moneyRewardAmount||'--')}}</div>
                        <div>{{scope.row.newCustomer&&(scope.row.newCustomer.couponRewardAmount)||'--'}}</div>
                    </template>
                    </el-table-column>
                    <el-table-column label="发放状态/操作时间" min-width="120">
                        <template slot-scope="scope">
                            <div>{{scope.row.newCustomer&&(scope.row.newCustomer.reward_status||'--')}}</div>
                            <div>{{scope.row.newCustomer&&scope.row.newCustomer.reward_date}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
            </template>
            <template  slot="before" v-else-if="selectTab==='OLD'">
              <el-table-column label="用户名">
                <template slot-scope="scope">
                  {{scope.row.oldCustomer&&scope.row.oldCustomer.userName}}
                </template>
              </el-table-column>
              <el-table-column label="手机号">
                <template slot-scope="scope">
                {{scope.row.oldCustomer&&scope.row.oldCustomer.userMobile}}
                </template>
              </el-table-column>
              <el-table-column label="达标时间">
                <template slot-scope="scope">
                  {{scope.row.achieve_date}}
                </template>
              </el-table-column>
              <el-table-column label="绑定合同时间">
                <template slot-scope="scope">
                  {{scope.row.oldCustomer&&scope.row.oldCustomer.CPSbindDate}}
                </template>
              </el-table-column>
              <el-table-column label="CPS合同" min-width="120">
                <template slot-scope="scope">
                  <template v-if="scope.row.oldCustomer&&scope.row.oldCustomer.contractInformation">
                      <div v-for="(item,i) in scope.row.oldCustomer.contractInformation" :key="i">
                        {{item.contractCode?item.contractCode:'--'}}
                      </div>
                      </template>
                </template>
              </el-table-column>
              <el-table-column label="地区">
                <template slot-scope="scope">
                  <template v-if="scope.row.oldCustomer&&scope.row.oldCustomer.contractInformation">
                    <div v-for="(item,i) in scope.row.oldCustomer.contractInformation" :key="i">
                      {{item.cpsRegion?item.cpsRegion:'--'}}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="产品" min-width="180">
                  <template slot-scope="scope">
                    <template v-if="scope.row.oldCustomer&&scope.row.oldCustomer.contractInformation&&scope.row.oldCustomer.contractInformation.length">
                    <div v-for="(item,i) in scope.row.oldCustomer.contractInformation" :key="i"  :class="i+1<scope.row.oldCustomer.contractInformation.length?'production-name-code-buttom':null" >
                      <template v-if="item.productInformation&&item.productInformation.length">
                      <div v-for="(etem,index) in item.productInformation" :key="index">
                        {{etem.name?etem.name:"--"}}
                          <!-- {{etem.name?(etem.name+(etem.productCode?("-"+etem.productCode):'')):'--'}} -->
                      </div>
                      </template>
                      <template v-else>--</template>
                    </div>
                    </template>
                    <template v-else>--</template>
                  </template>
                </el-table-column>
                <el-table-column label="奖励轮次">
                  <template slot-scope="scope">
                    {{scope.row.oldCustomer.finalRewardCount}}
                  </template>
                </el-table-column>
              <el-table-column label="业务员">
                <template slot-scope="scope">
                <template v-if="scope.row.oldCustomer&&scope.row.oldCustomer.contractInformation&&scope.row.oldCustomer.contractInformation.length">
                  <div v-for="(item,i) in scope.row.oldCustomer.contractInformation" :key="i">
                    {{item.salesName?item.salesName:"--"}}
                  </div>
                </template>
                </template>
              </el-table-column>
              <el-table-column label="返现">
                <template slot-scope="scope">
                  {{scope.row.oldCustomer&&(scope.row.oldCustomer.moneyRewardAmount||'--')}}
                </template>
              </el-table-column>
              <el-table-column label="返券">
                <template slot-scope="scope">
                  {{scope.row.oldCustomer&&(scope.row.oldCustomer.couponRewardAmount||'--')}}
                </template>
              </el-table-column>
            </template>
            <template slot="before" v-else-if="selectTab==='NEW'">
              <el-table-column label="用户名">
                <template slot-scope="scope">
                  {{scope.row.newCustomer&&scope.row.newCustomer.userName}}
                </template>
              </el-table-column>
              <el-table-column label="手机号">
                <template slot-scope="scope">
                  {{scope.row.newCustomer&&scope.row.newCustomer.userMobile}}
                </template>
              </el-table-column>
                    <el-table-column label="常住地区" min-width="110">
                      <template slot-scope="scope">
                        <template v-if="scope.row.newCustomer&&scope.row.newCustomer.region">
                        {{scope.row.newCustomer.region.provinceName+
                        scope.row.newCustomer.region.cityName+scope.row.newCustomer.region.districtName}}
                        </template>
                        <template v-else>--</template>
                      </template>
                    </el-table-column>
              <el-table-column label="达标时间">
                <template slot-scope="scope">
                  {{scope.row.newCustomer&&scope.row.newCustomer.reward_date}}
                </template>
              </el-table-column>
              <el-table-column label="绑定合同时间">
                <template slot-scope="scope">
                  {{scope.row.newCustomer&&scope.row.newCustomer.CPSbindDate}}
                </template>
              </el-table-column>
              <el-table-column label="CPS合同" min-width="150">
                <template slot-scope="scope">
                  <template v-if="scope.row.newCustomer&&scope.row.newCustomer.contractInformation">
                    <div v-for="(item,i) in scope.row.newCustomer.contractInformation" :key="i">
                      {{item.contractCode?item.contractCode:'--'}}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="地区">
                <template slot-scope="scope">
                <template v-if="scope.row.newCustomer&&scope.row.newCustomer.contractInformation&&scope.row.newCustomer.contractInformation.length">
                  <div v-for="(item,i) in scope.row.newCustomer.contractInformation" :key="i">
                    {{item.cpsRegion?item.cpsRegion:'--'}}
                  </div>
                </template>
                </template>
              </el-table-column>
              <el-table-column label="产品">
                <template slot-scope="scope">
                  <template v-if="scope.row.newCustomer&&scope.row.newCustomer.contractInformation&&scope.row.newCustomer.contractInformation.length">
                    <div v-for="(item,i) in scope.row.newCustomer.contractInformation" :key="i"  :class="i+1<scope.row.newCustomer.contractInformation.length?'production-name-code-buttom':null" >
                      <template v-if="item.productInformation&&item.productInformation.length">
                      <div v-for="(etem,index) in item.productInformation" :key="index">
                        {{etem.name?etem.name:"--"}}
                          <!-- {{etem.name?(etem.name+(etem.productCode?("-"+etem.productCode):'')):'--'}} -->
                      </div>
                      </template>
                      <template v-else>--</template>
                    </div>
                    </template>
                    <template v-else>--</template>
                  <!-- <template v-if="scope.row.newCustomer&&scope.row.newCustomer.contractInformation&&scope.row.newCustomer.contractInformation[0]&&scope.row.newCustomer.contractInformation[0].productInformation">
                    <div v-for="(item,i) in scope.row.newCustomer.contractInformation[0].productInformation" :key="i">
                      {{(item.name?(item.name+'-'+item.productCode):item.productCode)||'--'}}
                    </div>
                  </template>
                  <template v-else>--</template> -->
                  <!-- {{scope.row.newCustomer&&scope.row.newCustomer.productCode}} -->
                </template>
                </el-table-column>
              <el-table-column label="业务员">
                <template slot-scope="scope">
                <template v-if="scope.row.newCustomer&&scope.row.newCustomer.contractInformation&&scope.row.newCustomer.contractInformation.length">
                  <div v-for="(item,i) in scope.row.newCustomer.contractInformation" :key="i">
                    {{item.salesName?item.salesName:"--"}}
                  </div>
                </template>
                </template>
              </el-table-column>
                <!-- <el-table-column label="生产医院">
                 <template slot-scope="scope">
                <template v-if="scope.row.newCustomer&&scope.row.newCustomer.contractInformation&&scope.row.newCustomer.contractInformation.length">
                  <div v-for="(item,i) in scope.row.newCustomer.contractInformation" :key="i">
                    {{item.birthHospital?item.birthHospital:'--'}}
                  </div>
                </template>
                </template>
                </el-table-column> -->
              <el-table-column label="返现">
                <template slot-scope="scope">
                  {{scope.row.newCustomer&&(scope.row.newCustomer.moneyRewardAmount||'--')}}
                </template>
              </el-table-column>
              <el-table-column label="返券">
                <template slot-scope="scope">
                  {{scope.row.newCustomer&&(scope.row.newCustomer.couponRewardAmount||'--')}}
                </template>
              </el-table-column>
            </template>
            <slot/>
        </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-old-to-new-table'

export default {
  name: 'pt-old-to-new-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 0
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    selectTab: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      selectRow: []
    }
  },
  methods: {
    select (row) {
      this.$emit('select', row)
    },
    selectAll (val) {
      this.$emit('selectAll', val)
    },
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    showReTry () {
      this.$refs.table.showReTry()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import "~less/var.less";
.pt-old-to-new-table{

    :global
    .wt-table{
        th{
            background-color: #fff!important
        }
        .el-table{
            tbody{
                .el-table_1_column_4_column_13 {
                    border-right:1px solid #ebeef5;
                }
            }
            .el-table__header{
                .el-table_1_column_4_column_13 {
                    border-right:1px solid #ebeef5;
                }
            }
            .is-group{
            th{
                &.is-center{
                    color: #222222;
                    font-size: 16px;
                    border-bottom:none;
                    border-right: none;
                    // border-right: 0.01rem solid ;
                    padding: 10px!important;
                    &:after{
                        content: '';
                        position: absolute;
                        top: 10px;
                        height: 60%;
                        width: 20px;
                        border:1px solid transparent;
                        right: 0;
                        border-right-color: #222;
                    }
                    .cell{
                        padding: 10px;
                    border-bottom:1px solid @mainColor;
                    }
                    &+.is-center{
                        &::after{
                            content: none

                        }
                    }
                }
            }
            }
        }
        .el-table--border,.el-table--group{
                 border: none;
                 td{
                     border-right:none
                 }
        }
        th{
            &.is-leaf{
                border-right:none
            }
        }
    }

}
</style>
<style lang="less">

.production-name-code-buttom{
  border-bottom:1px solid #000
}
</style>
